export default () => ({
    state: Alpine.$persist('unknown').as('cookieConsent'),
    init() {
        this.animate()
        this.dispatch()
    },

    dialogue: {
        ['x-show']() {
            return this.state === 'unknown'
        },
    },

    accept: {
        ['@click']() {
            this.state = 'accepted'
            this.dispatch()
        },
    },

    animate() {
        TweenMax.from(this.$refs.overlay, 0.4, {
            xPercent: 120,
            delay: this.$store.enterDelay + 0.6,
            ease: Circ.easeInOut,
        })
    },

    dispatch() {
        document.dispatchEvent(
            new CustomEvent('cookieConsent', {
                detail: this.state,
            }),
        )
    },
})
